import { put, call, takeLatest } from 'redux-saga/effects';

import { HealthActions } from "../constants/health";
import { createShowErrorAction } from "../actions/notifications";

import api from '../server/health';

const showErrorAction = createShowErrorAction();

export function* getPingEffect(action) {
  try {
    const result = yield call(api.getPing);
    
    if (!result) {
      yield put(showErrorAction(`Can't reach api`));
    }
  } catch (e) {
    yield put(showErrorAction(`Can't reach api`));
  }
}

export default [
    takeLatest(HealthActions.GetPing, getPingEffect),
];